import { render } from "./CustomersComponent.vue?vue&type=template&id=b260be46"
import script from "./CustomersComponent.vue?vue&type=script&lang=js"
export * from "./CustomersComponent.vue?vue&type=script&lang=js"

import "./CustomersComponent.vue?vue&type=style&index=0&id=b260be46&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__